const myPatterns = ['plus', 'cross', 'dash', 'cross-dash', 'dot', 'dot-dash', 'disc', 'ring', 'line', 'line-vertical', 'weave', 'zigzag', 'zigzag-vertical', 'diagonal', 'diagonal-right-left', 'square', 'box', 'triangle', 'triangle-inverted', 'diamond', 'diamond-box']
const infectList = ["Bocavirus", 'Bocavirus_WUPolyomavirus', 'Coronavirus 229E', 'Coronavirus 229E_Coronavirus OC43', 'Coronavirus 229E_Rhinovirus', 'Coronavirus HKU1', 'Coronavirus NL63', 'Coronavirus NL63_Respiratory syncytial virus B', 'Coronavirus OC43', 'Coronavirus OC43_Rhinovirus', 'Coronavirus OC43_WUPolyomavirus', 'Coronavirus OC43_Adenovirus_WUPolyomavirus', 'Coronavirus OC43_Rhinovirus', 'Coxackievirus', 'Enterovirus', 'Influenza A', 'Influenza A_Rhinovirus', 'Influenza B', 'Influenza C', 'Parainfluenza 2', 'Parainfluenza 4', 'RSVB_RhinovirusC_CoronavirusHKU1_ADC_WUPolyomavirus', 'Respiratory syncytial virus', 'Respiratory syncytial virus A', 'Respiratory syncytial virus B', 'Rhinovirus', 'Rhinovirus_Coronavirus OC43', 'Rhinovirus_Coronavirus229E'];

async function createVirusChart() {

	let patients = document.getElementById("viruspatient").value.toString().split(",");

	//calculate bacterial abundance
	var finalData = await virusCounter(patients);

	let chartStatus = Chart.getChart("virusChart");
	if (chartStatus != undefined) {
		chartStatus.destroy()
	} //end of destroying chart

	//create chart
	const formatter = new Intl.NumberFormat('en-US', {minimumFractionDigits: 6});
	window.myChart = new Chart(document.getElementById("virusChart").getContext('2d'), {
        	type: "line", data: finalData,
		options: { 
			legend: {display: false}, responsive: true,
                	plugins: {
				title: { display: true, text: "Relative Bacterial Abundance of Patient(s) " + patients,
					font: { size: 20, weight: 'bold'} }, //end of title
			}, scales: {
				x: { title: { display: true, text: "Days" }, 
				stacked: true
				}, y: { title: { display: true, text: "Relative Bacterial Abundance"}, stacked: false }   } } }); //end of scale, options, chart
} // end of createVirusChart()

//function to quantify the relative abundance of bacteria per day
async function virusCounter(patients) {
	const keys = ["h_infl_fraction_kracken", "s_oralis_fraction_kracken", "h_parainfl_fraction_kracken", "s_pneumo_fraction_kracken", "s_pseudo_fraction_kracken", "s_saliv_fraction_kracken"]
	let myPtids = await getPtids(patients)

	//create table w name of infection and counts
	var max = 0, allLabels = [], myDataset = []; 

	//iterate through patients 
	for (var patient = 0; patient < patients.length; patient++) {
		let abundanceData = []

		//fetch virus data to get the cgcids, i think might also need date - FUCK
		let response = await fetch(URL + 'list/virus/?ptid=' + myPtids[patient]);
		let data = await response.json();

		const myCgcs = data.map(item => item.cgcid);

		//sort data according to date before proceeding
		data.sort(function(a, b){
			let date_a = parseInt(a.date_collected), date_b = parseInt(b.date_collected);
        		return date_a - date_b;
		});

		//iterating through cgcIds, grabbing kraken bacterial abundance
		for (var i = 0; i < data.length; i++) {
			let thisResponse = await fetch(URL + 'list/kraken/?sample=' + data[i].cgcid);
			let krakenData = await thisResponse.json();
			
			let myDate = data[i].date_collected
			allLabels.push(myDate)

			// uses maps to get the bacterial abundance, then push to the dataset
			var h_infl = krakenData.map(item => Number(item.h_infl_fraction_kracken).toPrecision(6));
				abundanceData.push({x:myDate, y: h_infl});
			var s_oralis = krakenData.map(item => Number(item.s_oralis_fraction_kracken).toPrecision(6));
				abundanceData.push({x:myDate, y: s_oralis});
			var h_parainfl = krakenData.map(item => Number(item.h_parainfl_fraction_kracken).toPrecision(6));
				abundanceData.push({x:myDate, y: h_parainfl});
			var s_pneumo = krakenData.map(item => Number(item.s_pneumo_fraction_kracken).toPrecision(6));
				abundanceData.push({x:myDate, y: s_pneumo});
			var s_pseudo = krakenData.map(item => Number(item.s_pseudo_fraction_kracken).toPrecision(6));
				abundanceData.push({x:myDate, y: s_pseudo});
			var s_saliv = krakenData.map(item => Number(item.s_saliv_fraction_kracken).toPrecision(6));
				abundanceData.push({x:myDate, y: s_saliv});

			if (Math.max(h_infl,s_oralis,h_parainfl,s_pneumo, s_pseudo, s_saliv) > max) { max = Math.max(h_infl,s_oralis,h_parainfl,s_pneumo, s_pseudo, s_saliv) }

		} //end of i in data.length	

		for (var index = 0; index < keys.length; index++) {
			let slicedScores = []

			for (let section  = 0; section < abundanceData.length; section+=6) {
				slicedScores.push(abundanceData.slice(section, section+6)[index])
			}
		
			const infectColor=['#ba55d3','#00fa9a','#dc143c','#000000','#c0c0c0','#2f4f4f','#556b2f','#8b4513','#6b8e23','#7f0000','#483d8b','#008000','#3cb371','#008080','#4682b4','#d2691e','#9acd32','#cd5c5c','#00008b','#32cd32','#daa520','#7f007f','#8fbc8f','#b03060','#d2b48c','#ff0000','#00ced1','#ff8c00','#ffd700','#6a5acd','#ffff00','#00ff00','#9400d3','#00bfff','#f4a460','#0000ff','#adff2f','#ff6347','#ff00ff','#f0e68c','#6495ed','#dda0dd','#ff1493','#afeeee','#98fb98','#7fffd4','#ff69b4','#fff8dc','#ffb6c1'];

			myDataset[myDataset.length] = {
				type: "line",
				data: slicedScores,
				label: formatStrain(keys[index]) + " | Patient " + patients[patient],
				backgroundColor: infectColor[myDataset.length],
				borderColor: infectColor[myDataset.length]}

		}//end of keys.length loop
	} //end of patient loop

        var uniqueDates = allLabels.filter((value, index) => {
                return allLabels.indexOf(value) === index;
        });

        let myLabels = uniqueDates.sort(function(a, b){return a-b});

	myDataset = await getViralInfections(patients, myPtids, myDataset, myLabels, max)
	return {labels: myLabels, datasets: myDataset};

} //end of virusCounter()


function formatStrain(strain) {
	//create a dictionary object of strains and their scientific name
	const dict = {"h_infl_fraction_kracken":"H. Influenzae", "s_oralis_fraction_kracken":"S. Oralis", "h_parainfl_fraction_kracken":"H. Parainfluenza", "s_pneumo_fraction_kracken":"S. Pneumoniae", "s_pseudo_fraction_kracken":"S. Pseudopneumoniae", "s_saliv_fraction_kracken":"S. Salivarius"}	
	return dict[strain];
}

async function getPtids(myIds){ 

	let finalIds = []

	let test = await fetch(URL + 'list/ptids/')
	let testDat = await test.json();
	const ptids = testDat.map(item => item.ptid);


	for (myId in myIds) {
		//perform fetch
		finalIds.push(ptids[Number(myIds[myId]-1)]);
	}

	return finalIds
}

async function getViralInfections(patients, myPtids, myDataset, myLabels, max) {

	for (j = 0; j < infectList.length; j++) {
		let myInfection = infectList[j] 
		       
		for (pat in patients) {    
			infectVals = new Array(myLabels.length).fill(0), activeInfection = false

			//fetch again for viral info
			let patResponse = await fetch(URL + 'list/virus/?infection_type=' + myInfection + "&ptid=" + myPtids[pat])
			let patData = await patResponse.json()
			
			if (patData.length > 0) {
				patData.sort(function(a, b){
				let date_a = parseInt(a.date_collected), date_b = parseInt(b.date_collected);
        			return date_a - date_b});
				
				//iterate through and grab for our patients, start index at 1 to leave out None infection
				for (i = 0; i < patData.length; i++) {
					activeInfection = true
					infectVals.splice(myLabels.indexOf(patData[i].date_collected), 1, Number(max).toPrecision(2))
				} //end of i in patData

				let currentColor = getVColors(myInfection)
				//if there's an infection, fill out the dataset with the information

				if (activeInfection && myInfection != "None") {
					myDataset[myDataset.length] = {
					data: infectVals,
					label: myInfection + " | Patient " + patients[pat],
					backgroundColor: currentColor,
					borderColor: currentColor,
					pattern: true,
					barPercentage: 0.25,
					type: "bar"}
				} //end of infection to dataset
			} //end of dataLen > 0
		}// end of pats
	} //end of infect in infectList

	return myDataset;
}

function getVColors(myInfection) {
	const infectList = ["Bocavirus", 'Bocavirus_WUPolyomavirus', 'Coronavirus 229E', 'Coronavirus 229E_Coronavirus OC43', 'Coronavirus 229E_Rhinovirus', 'Coronavirus HKU1', 'Coronavirus NL63', 'Coronavirus NL63_Respiratory syncytial virus B', 'Coronavirus OC43', 'Coronavirus OC43_Rhinovirus', 'Coronavirus OC43_WUPolyomavirus', 'Coronavirus OC43_Adenovirus_WUPolyomavirus', 'Coronavirus OC43_Rhinovirus', 'Coxackievirus', 'Enterovirus', 'Influenza A', 'Influenza A_Rhinovirus', 'Influenza B', 'Influenza C', 'Parainfluenza 2', 'Parainfluenza 4', 'RSVB_RhinovirusC_CoronavirusHKU1_ADC_WUPolyomavirus', 'Respiratory syncytial virus', 'Respiratory syncytial virus A', 'Respiratory syncytial virus B', 'Rhinovirus', 'Rhinovirus_Coronavirus OC43', 'Rhinovirus_Coronavirus229E'];
	const infectColor=['#000000','#c0c0c0','#2f4f4f','#556b2f','#8b4513','#6b8e23','#7f0000','#483d8b','#008000','#3cb371','#008080','#4682b4','#d2691e','#9acd32','#cd5c5c','#00008b','#32cd32','#daa520','#7f007f','#8fbc8f','#b03060','#d2b48c','#ff0000','#00ced1','#ff8c00','#ffd700','#6a5acd','#ffff00','#00ff00','#9400d3','#ba55d3','#00fa9a','#dc143c','#00bfff','#f4a460','#0000ff','#adff2f','#ff6347','#ff00ff','#f0e68c','#6495ed','#dda0dd','#ff1493','#afeeee','#98fb98','#7fffd4','#ff69b4','#fff8dc','#ffb6c1'];

    let index = infectList.indexOf(myInfection)
	let myPattern = index % infectList.length;
    return pattern.draw(myPatterns[myPattern], infectColor[index]);
}
